import { Routes } from "@/features/router";
import {
  PaperAirplaneIcon,
  ArrowDownOnSquareIcon,
  ArrowUpOnSquareIcon,
  ArrowPathRoundedSquareIcon,
  ChartPieIcon,
  BeakerIcon
} from "@heroicons/react/20/solid";
import _ from "lodash";
import type React from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { MenuItem } from "./index.react";
import { ChevronLeftIcon } from "@heroicons/react/24/solid";
import { CardTitle, Info } from "@/atoms-react/text/Text.react";
import { useMediaQuery } from "usehooks-ts";

type MenuWalletProps = {
  open: boolean;
  onClose: () => void;
} & React.ComponentPropsWithoutRef<"div">;

export const MenuWallet = ({ open, onClose, ...props }: MenuWalletProps) => {
  const { t } = useTranslation(["pass"]);
  const isNotMobile = useMediaQuery("(min-width: 768px)");

  return (
    <div
      className={twMerge(
        "absolute h-full w-64 shrink-0 border-slate-50 border-r bg-white px-4 py-6 lg:relative lg:w-80 lg:px-8 dark:border-slate-900 dark:bg-slate-950",
        "dark: -translate-x-full transition-all lg:translate-x-0",
        "z-50 overflow-auto",
        open ? "translate-x-0" : ""
      )}
      {..._.omit(props, "className")}
    >
      <div
        className={twMerge("mb-4 flex cursor-pointer items-center gap-x-1", isNotMobile && "h-12")}
        onClick={onClose}
      >
        <ChevronLeftIcon className="h-5 w-5 text-black dark:text-white" />
        <CardTitle className="block">
          {t("olkypass.mainPage.navigation_menu.link.my_wallet")}
        </CardTitle>
      </div>
      {isNotMobile && <Info className="mt-10 block"></Info>}
      <MenuItem to={Routes.wallet_dashboard} icon={(p) => <ChartPieIcon {...p} />}>
        {t("olkypass.mainPage.navigation_wallet_menu.link.identity")}
      </MenuItem>
      <MenuItem to={Routes.wallet_form} icon={(p) => <BeakerIcon {...p} />}>
        Forms
      </MenuItem>
      <MenuItem to={Routes.wallet_buy} icon={(p) => <ArrowDownOnSquareIcon {...p} />}>
        {t("olkypass.mainPage.navigation_wallet_menu.link.olkyWalletBuy")}
      </MenuItem>
      <MenuItem to={Routes.wallet_sell} icon={(p) => <ArrowUpOnSquareIcon {...p} />}>
        {t("olkypass.mainPage.navigation_wallet_menu.link.olkyWalletSell")}
      </MenuItem>
      <MenuItem to={Routes.wallet_convert} icon={(p) => <ArrowPathRoundedSquareIcon {...p} />}>
        {t("olkypass.mainPage.navigation_wallet_menu.link.olkyWalletConvert")}
      </MenuItem>
      <MenuItem to={Routes.wallet_transfer} icon={(p) => <PaperAirplaneIcon {...p} />}>
        {t("olkypass.mainPage.navigation_wallet_menu.link.olkyWalletTransfer")}
      </MenuItem>
    </div>
  );
};
